import React from "react";
import styles from "./Response.module.css";
import { Truncate } from "components/Truncate";
import { ResponseActions } from "components/response";
import { useImagePreview } from "hooks";
import { FA } from "components/FA";
import { Loading } from "components/Utils";

const ResponseRow = ({
  response,
  className,
  style,
  handleResize,
  toggleDetail,
  actions,
  title,
}) => {
  const [image, isImage, isLoading] = useImagePreview(response);
  if (response == null) {
    return (
      <div className={className} style={style}>
        <div className={styles.row}>
          <Loading />
        </div>
      </div>
    );
  }
  return (
    <div className={className} style={style} title={title}>
      <div className={styles.row} onClick={toggleDetail}>
        {image && (
          <img
            className={styles.image}
            src={image}
            alt={response.abstract || response.title}
          />
        )}
        {isLoading && (
          <span className={styles.image}>
            {isImage ? <Loading /> : <FA icon="file" size="5x" />}
          </span>
        )}
        <h3 className={styles.title}>
          {response.title ? response.title : "(No title)"}
        </h3>
        {response.note && (
          <aside className={styles.note}>
            <FA icon="comment" />
            {response.note}
          </aside>
        )}
        <div className={styles.meta}>
          {response.date ? (
            <span className={styles.date}>
              {new Date(response.date).toLocaleDateString()}{" "}
            </span>
          ) : (
            response.year && (
              <span className={styles.date}>{response.year} </span>
            )
          )}
          {response.persons && (
            <ul className={styles.persons}>
              {response.persons.map((person, i) => (
                <li className={styles.person} key={`${response.id}-${i}`}>
                  {person.name}
                </li>
              ))}
            </ul>
          )}
        </div>
        {response.abstract && (
          <Truncate className={styles.abstract}>{response.abstract}</Truncate>
        )}
        <ResponseActions
          className={`${styles.actions}${
            actions && actions.web ? ` ${styles.web}` : ""
          }`}
          response={response}
          {...actions}
        />
      </div>
    </div>
  );
};

const PersonalRow = (props) => (
  <ResponseRow {...props} actions={{ personal: true }} />
);
const WebRow = (props) => <ResponseRow {...props} actions={{ web: true }} />;

export { ResponseRow, PersonalRow, WebRow };
